import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { chat as defaultChat } from '../../../theme/tokens/semantic';
import { shadows as defaultShadows } from '../../../theme/tokens/shadows';
import { createDashboardHubSx } from '../styles/dashboardHubLayout';

export default function useDashboardHubSx() {
  const theme = useTheme();

  return useMemo(() => {
    const chat = theme.palette?.chat ?? defaultChat;
    const accent = {
      primary: chat.primary,
      primaryDark: chat.primaryDark,
      primaryMuted: chat.primaryMuted,
      primaryBorder: chat.primaryBorder,
      divider: chat.divider ?? theme.palette?.divider,
      textPrimary: chat.textPrimary,
      textSecondary: chat.textSecondary,
    };

    return createDashboardHubSx({
      accent,
      shadows: theme.customTokens?.shadows ?? defaultShadows,
    });
  }, [theme]);
}
